import { render, staticRenderFns } from "./02.vue?vue&type=template&id=8222d59c&scoped=true&"
import script from "./02.vue?vue&type=script&lang=js&"
export * from "./02.vue?vue&type=script&lang=js&"
import style0 from "./02.vue?vue&type=style&index=0&id=8222d59c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8222d59c",
  null
  
)

export default component.exports